import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

import {CuentasBancariasService, PageBusquedaObject, CtaBancaria} from '../cuentas-bancarias.service';

import { LoginService } from '../../../login/login.service';

import {GralMon} from '../../../entity/GralMon';

@Component({
  selector: 'app-catalogo-cuentas-bancarias',
  templateUrl: './catalogo-cuentas-bancarias.component.html',
  styleUrls: ['./catalogo-cuentas-bancarias.component.css'],
  preserveWhitespaces: true
})
export class CatalogoCuentasBancariasComponent implements OnInit {

  busqueda: PageBusquedaObject = new PageBusquedaObject();
  totalItems: number;
  rotate: any;
  items: CtaBancaria[];

  @ViewChild('no_cuenta') no_cuenta: ElementRef;

  constructor(
    private router: Router,
    private ctaBanService: CuentasBancariasService,
    public loginService: LoginService
  ) {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 10;
    this.busqueda.pageNumber = 0;
  }

  ngOnInit(): void {
    this.cargarCatalogo();
  }

  cargarCatalogo() {
    this.ctaBanService.catalogo(this.busqueda).subscribe(response => {
      this.items = response.contenido.content;
      this.totalItems = response.contenido.totalItems;
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }

  eliminar(dtoDelete: CtaBancaria): void {
    Swal.fire({
      title: 'Atención',
      text: `¿Está seguro de dar de baja este elemento?`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.value) {
        this.ctaBanService.delete(dtoDelete.id, this.loginService.usuario.id).subscribe(response => {
          Swal.fire('TNK Ledger', response.mensaje, 'success');
          this.buscarEnCatalogo();
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          })
          console.log(err);
        });
      }
    });
  }

  sortearPor(columnName: any): void {
    console.log('columnName ', columnName);
    this.busqueda.column = columnName;
    this.busqueda.sort = true;
    this.busqueda.pageNumber = 0;
    switch (this.busqueda.order) {
      case 'desc':
        this.busqueda.order = 'asc';
        break;
      default:
        this.busqueda.order = 'desc';
        break;
    }
    this.cargarCatalogo();
  }

  cambiarPagina(event: any): void {
    this.busqueda.pageNumber = event.page - 1;
    this.cargarCatalogo();
  }

  buscarEnCatalogo(): void {
    this.busqueda.pageNumber = 0;
    this.cargarCatalogo();
  }

  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }

  limpiarBusqueda(): void {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 10;
    this.busqueda.pageNumber = 0;
    this.no_cuenta.nativeElement.value = '';
    this.cargarCatalogo();
  }

}
